import axios from '../utils/axios';

export default function uploadVerificationDocument(adminId, data) {
    return axios.post(`/admin/${adminId}/upload-verification-document`, data);
}